import { render } from "./LoadersPage.vue?vue&type=template&id=1e1242f6"
import script from "./LoadersPage.vue?vue&type=script&lang=js"
export * from "./LoadersPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__